import React, {Fragment} from 'react'
import {Popover} from 'common/styleguide/Popover'
import {Icon} from 'common/Icon'
import styles from './PopoverFilter.scss'
import cx from 'classnames'

export class PopoverFilter extends React.PureComponent {
  state = {
    expanded: false
  }

  toggleExpand = () => {
    !this.props.disabled && this.setState({expanded: !this.state.expanded})
  }

  render () {
    const {label, icon, innerLabel, hidePopoverLabel, children, className, disabled, ...props} = this.props
    const {expanded} = this.state

    return (
      <Fragment>
        <FilterButton
          onClick={this.toggleExpand}
          ref={r => { this._trigger = r }}
          disabled={disabled}
          data-tip
          title={disabled && 'Follow a collection to enable filtering'}
          className={cx(className, expanded && styles.expanded)}>
          {label} {!icon ? <Icon i='ios-arrow-down' /> : icon}
        </FilterButton>
        {!disabled && expanded && <Popover
          onRequestClose={this.toggleExpand}
          target={this._trigger}
          placement='bottom'
          {...props}>
          {!hidePopoverLabel && <div className={styles.innerLabel}>{innerLabel === undefined ? label : innerLabel}:</div>}
          {typeof children === 'function'
            ? children({toggleExpand: this.toggleExpand})
            : children}
        </Popover>}
      </Fragment>
    )
  }
}

export const FilterButton = React.forwardRef(({className, children, valignCenter, disabled, ...props}, ref) => (
  <button
    className={cx(className, styles.trigger, valignCenter && styles.valignCenter, disabled && styles.disabled)}
    ref={ref}
    {...props}>
    {children}
  </button>
))
